"use client";

import CourseDetailSkeleton from "@/components/student/CourseDetailSkeleton";
import { dynamic } from "@/src/lib/next-compat";

const CourseDetailPageClient = dynamic(
    () => import("@/components/student/CourseDetailPageClient"),
    {
        ssr: false,
        loading: () => <CourseDetailSkeleton listPreview={null} />,
    },
);

export default function CourseDetailPage() {
    return <CourseDetailPageClient />;
}
